module.exports = __webpack_public_path__ + "static/img/no-data.9c2875cb.png";